import React from "react";
import ComponenetHeader from "../common/ComponenetHeader";

const PrivacyPolicy = () => {

  return (<>

    {/* <ComponenetHeader
           name={'Privacy Policy'}
        />  */}

    <section className="content_page text-left">
      <div className="container">
        <div className="row content_page_style justify-content-center">
          <div className="col-md-12">
            <h2 className="mb-4">Privacy Policy</h2>
            <h3>Introduction</h3>
            <p>
              At <strong>Mechanic Hunt</strong>, we are committed to protecting your privacy and handling any personal information ("Personal Information") you provide with the highest level of care. This policy explains how we collect, use, and safeguard your information while you use our platform.
            </p>
            <p>
              By accessing or using our services, you acknowledge and agree to the practices described in this Privacy Policy.
            </p>

            <h3>Personal Information</h3>
            <p>
              "Personal Information" refers to any details that can be used to identify an individual, such as names, email addresses, physical addresses, phone numbers, or any other related data.
            </p>
            <p>
              We may update this policy occasionally without prior notice. The most current version will always be available on our website. Continued use of our platform indicates your acceptance of these updates.
            </p>

            <h3>Cookies</h3>
            <p>
              Cookies are small data files stored on your device that help us recognize returning users, customize your experience, and improve service performance.
            </p>
            <p>
              Most browsers allow cookies by default, but you may adjust your settings to disable them. Please note that turning off cookies may limit certain features or reduce the functionality of our website.
            </p>

            <h3>How We Use Your Information</h3>
            <p>Information collected through our platform is used to:</p>
            <ul>
              <li>Create and maintain your account.</li>
              <li>Support secure login and authentication processes.</li>
              <li>Provide rewards for bill uploads and enable other platform features.</li>
              <li>Send updates, notifications, offers, and important communications.</li>
              <li>Enhance the functionality, performance, and user experience of our services.</li>
              <li>Meet legal or regulatory requirements.</li>
            </ul>

            <h4>Rewards and Bill Uploads</h4>
            <p>
              When you upload bills within the app, we store those documents securely to verify your eligibility for rewards. These documents are not used for marketing, nor are they shared with third parties. Participation in the rewards program is completely optional.
            </p>

            <h4>We do not sell or share your Personal Information for marketing purposes.</h4>
            <p>Mechanic Hunt collects information through:</p>
            <ul>
              <li>Use of our website, mobile site, and mobile applications.</li>
              <li>Electronic communications such as SMS, email, or in-app messages.</li>
              <li>Interactions on social media platforms, including Facebook, Instagram, LinkedIn, YouTube, and others.</li>
            </ul>
            <p>
              Please be aware that third-party websites or platforms have their own privacy policies, and we are not responsible for their practices.
            </p>

            <h4>Disclosure of Your Personal Information</h4>
            <p>Mechanic Hunt may disclose your Personal Information under the following circumstances:</p>
            <ul>
              <li>When sharing information through co-branded services or partnered platforms.</li>
              <li>With trusted third-party service providers who assist in our business operations.</li>
              <li>During business transitions such as mergers, acquisitions, or asset transfers.</li>
              <li>When required by law, legal processes, or to protect our rights and users.</li>
            </ul>
            <p>
              While we do not sell Personal Information, we may disclose the names of businesses or vendors associated with user accounts on our platform. Feedback shared by users may also be provided to service providers, but only with the user’s prior consent.
            </p>

            <h4>Consent</h4>
            <p>
              By submitting your Personal Information, you consent to its collection, storage, processing, and disclosure as outlined in this policy.
            </p>
            <p>
              We may notify you of major updates to this policy via email or website announcements. Please keep your contact information current and revisit this policy periodically.
            </p>

            <h4>Security Measures</h4>
            <p>
              Your privacy is important to us, and we implement reasonable safeguards to protect your data. However, security also depends on you—please keep your account credentials secure and avoid sharing sensitive details in public spaces.
            </p>
            <p>
              Despite our efforts, no online data transmission is 100% secure. Any information you share with us is provided at your own discretion and risk.
            </p>

            <h5>Contact Information</h5>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us at:
              <strong>mechanichunt@gmail.com</strong>
            </p>

          </div>

        </div>
      </div>
    </section>

  </>
  );
};

export default PrivacyPolicy;